import { useStyles } from '@archipro-design/aria';
import type { MouseEventHandler } from 'react';
import React from 'react';
import { useProductTagging } from '../../context';
import * as S from './ProductTaggingClickableArea.style';

interface ProductTaggingClickableAreaProps {
    onClick: MouseEventHandler<HTMLElement>;
}

const PRODUCT_TAGGING_CLICKABLE_AREA_CLASS = 'product-tagging-clickable-area';

const ProductTaggingClickableArea = ({
    onClick,
}: ProductTaggingClickableAreaProps) => {
    const {
        state: { isTagging },
    } = useProductTagging();
    const { css } = useStyles({ isTagging });
    const clickableAreaRef = React.useRef<HTMLDivElement>(null);

    return (
        <div
            className={`${css(
                S.ProductTaggingClickableArea,
            )} ${PRODUCT_TAGGING_CLICKABLE_AREA_CLASS}`}
            onClick={onClick}
            ref={clickableAreaRef}
        ></div>
    );
};

export default ProductTaggingClickableArea;
